import React from "react";
import { FaCheck } from "react-icons/fa6";
import Reveal from "./Reveal";
import { trackEvent } from "../lib/analytics";
import imgPrincipal from "../assets/images/11.jpeg";
import imgSecundaria from "../assets/images/9.jpeg";

// TODO: revisar este texto — es un borrador. Conviene sumar el año de fundación
// real y algún proyecto concreto del que estén orgullosos.
const diferenciales = [
  "Proyecto y cálculo hídrico antes de vender un equipo",
  "Instalación con personal propio, no tercerizada",
  "Representamos marcas líderes: Rain Bird, T-L y Sylwan",
  "Service y repuestos después de la entrega",
];

const About = () => {
  return (
    <section id="nosotros" className="overflow-hidden bg-white py-20 sm:py-28">
      <div className="container-site">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
          {/* Composición de imágenes */}
          <Reveal className="relative">
            <div className="overflow-hidden rounded-2xl shadow-card-hover">
              <img
                src={imgPrincipal}
                alt="Pivote central regando un lote de colza al atardecer"
                loading="lazy"
                decoding="async"
                className="aspect-[4/3] w-full object-cover"
              />
            </div>

            <div className="absolute -bottom-8 -right-2 hidden w-48 overflow-hidden rounded-xl border-4 border-white shadow-card-hover sm:block lg:-right-8 lg:w-56">
              <img
                src={imgSecundaria}
                alt="Equipo de Riego Mercedes montando un pivote central en el lote"
                loading="lazy"
                decoding="async"
                className="aspect-square w-full object-cover"
              />
            </div>
          </Reveal>

          {/* Texto */}
          <Reveal delay={120}>
            <p className="section-eyebrow">Quiénes somos</p>
            <h2 className="section-title">
              Conocemos el campo porque estamos en él
            </h2>

            <div className="mt-5 space-y-4 text-base leading-relaxed text-slate-600">
              <p>
                Riego Mercedes es una empresa de Villa Mercedes, San Luis,
                dedicada a la venta, el diseño y la instalación de sistemas de
                riego. Trabajamos con productores agropecuarios, municipios,
                clubes y particulares de toda la región.
              </p>
              <p>
                No vendemos equipos de catálogo: primero vamos al lote,
                relevamos las condiciones reales y recién ahí proponemos una
                solución.
              </p>
            </div>

            <ul className="mt-8 space-y-3.5">
              {diferenciales.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span
                    className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-campo-100 text-campo-700"
                    aria-hidden="true"
                  >
                    <FaCheck size={10} />
                  </span>
                  <span className="text-sm leading-relaxed text-slate-700">
                    {item}
                  </span>
                </li>
              ))}
            </ul>

            <a
              href="#contacto"
              onClick={() => trackEvent("cta_click", { location: "about" })}
              className="btn-primary mt-9"
            >
              Hablemos de su proyecto
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
